define('AwaLabs.EndlessShelfProducts', [
    'EndlessShelfProducts.Facets.ItemCell.View'
], function AwaLabsEndlessShelfProducts() {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var cart = application.getComponent('Cart');
            var pdp = application.getComponent('PDP');
            if (cart) {
                cart.addToViewContextDefinition('Cart.Lines.View', 'endlessProduct', 'string', function fnEndlessProduct(context) {
                    return context.line && context.line.item && context.line.item.custitem_endless_shelf_message;
                });
            }
            if (pdp) {
                pdp.addToViewContextDefinition('Cart.Confirmation.View', 'endlessProduct', 'string', function fnEndlessProduct(context) {
                    return context.model && context.model.item && context.model.item.custitem_endless_shelf_message;
                });
            }
        }
    };
});
